function IsPC() {
        var userAgentInfo = navigator.userAgent;
        var Agents = ["Android", "iPhone",
                    "SymbianOS", "Windows Phone",
                    "iPad", "iPod"];
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                flag = false;
                break;
            }
        }
        return flag;
    };
    $(document).ready(function(){
        var isPC=IsPC();
        if(isPC){
          
      }
        else{
           $(document).ready(function(){
              $(".flip").click(function(){
                  $(".panel_m").slideToggle("5000");
                });
           });
        }
    }); 

  function show_s (event) {
        let oevent = event || window.event
        if (document.all) {
            oevent.cancelBubble = true
        } else {
            oevent.stopPropagation()
        }
        if (document.getElementById('info_sale_three_box').style.display === 'none' || document.getElementById('info_sale_three_box').style.display === '') {
            document.getElementById('info_sale_three_box').style.display = 'block'
        } else {
            document.getElementById('info_sale_three_box').style.display = 'none'
        }
    }
    document.onclick = function () {
        document.getElementById('info_sale_three_box').style.display = 'none'
    }
    document.getElementById('info_sale_three_box').onclick = function (event) {
        let oevent = event || window.event
        oevent.stopPropagation()
    }
    $(document).click(function() {
    $("#info_sale_three_box").hide();
    });

var content = document.getElementById("content_one").innerText;
		var text = document.getElementById("text_one");
		var CopyBtn = document.getElementById("CopyBtn_one");
		CopyBtn.onclick = function(){
			text.value = content;
			text.select();
			document.execCommand("copy");
			alert(content + " Copy successfully");
		}
		var content1 = document.getElementById("content_two").innerText;
		var text1 = document.getElementById("text_two");
		var CopyBtn1 = document.getElementById("CopyBtn_two");
		CopyBtn1.onclick = function(){
			text1.value = content1;
			text1.select();
			document.execCommand("copy");
			alert(content1 + " Copy successfully");
		}
        var content2 = document.getElementById("content_three").innerText;
		var text2 = document.getElementById("text_three");
		var CopyBtn2 = document.getElementById("CopyBtn_three");
		CopyBtn2.onclick = function(){
			text2.value = content2;
			text2.select();
			document.execCommand("copy");
			alert(content2 + " Copy successfully");
		}
        var content3 = document.getElementById("content_four").innerText;
		var text3 = document.getElementById("text_four");
		var CopyBtn3 = document.getElementById("CopyBtn_four");
		CopyBtn3.onclick = function(){
			text3.value = content3;
			text3.select();
			document.execCommand("copy");
			alert(content3 + " Copy successfully");
}

	    var content5 = document.getElementById("content_one1").innerText;
		var text5 = document.getElementById("text_one1");
		var CopyBtn5 = document.getElementById("CopyBtn_one1");
		CopyBtn5.onclick = function(){
			text5.value = content;
			text5.select();
			document.execCommand("copy");
			alert(content5 + " Copy successfully");
		}
		var content6 = document.getElementById("content_two1").innerText;
		var text6 = document.getElementById("text_two1");
		var CopyBtn6 = document.getElementById("CopyBtn_two1");
		CopyBtn6.onclick = function(){
			text6.value = content1;
			text6.select();
			document.execCommand("copy");
			alert(content6 + " Copy successfully");
		}
        var content7 = document.getElementById("content_three1").innerText;
		var text7 = document.getElementById("text_three1");
		var CopyBtn7 = document.getElementById("CopyBtn_three1");
		CopyBtn7.onclick = function(){
			text7.value = content2;
			text7.select();
			document.execCommand("copy");
			alert(content7 + " Copy successfully");
		}
        var content8 = document.getElementById("content_four1").innerText;
		var text8 = document.getElementById("text_four1");
		var CopyBtn8 = document.getElementById("CopyBtn_four1");
		CopyBtn8.onclick = function(){
			text8.value = content3;
			text8.select();
			document.execCommand("copy");
			alert(content8 + " Copy successfully");
		}
        
 